import { getInspectorsAdapter } from '../adapters/createServiceRequest/createServiceRequestAdapter';

import { apiAdminContracts } from './apiInstances';

export const postApproversContracts = async (body) => {
  const result = await apiAdminContracts.post('/v1/SolicitudesServicios/aprobadores', body);

  return result.data;
};

export const getProviders = async (idBusinessUnit, idService, providerName) => {
  const baseUrl = '/v1/SolicitudesServicios/proveedores';
  const result = await apiAdminContracts.get(
    `${baseUrl}?nombreProveedor=${providerName}&unidadNegocioId=${idBusinessUnit}${
      idService ? `&servicioId=${idService}` : ''
    }`
  );

  return result.data;
};

export const getContractToASDS = async (body) => {
  const url = '/v1/SolicitudesServicios/contratos/config';
  const result = await apiAdminContracts.post(url, body);

  return result.data;
};
export const getOymExpiredContracts = async ({ servicioId, operacionId, proveedorId }) => {
  const requestBody = {
    proveedorId,
    operacionId,
    servicioId
  };
  const baseUrl = 'v1/SolicitudesServicios/contratosVencidosHabilitados/operaciones';
  const result = await apiAdminContracts.post(baseUrl, requestBody);

  return result.data;
};

export const getEymExpiredContracts = async ({
  idService,
  idBusinessUnit,
  Providerid,
  requireRequest = null,
  eventoId = null
}) => {
  const baseUrl = 'v1/SolicitudesServicios/contratosVencidosHabilitados/equipoTorre';
  const body = {
    proveedorId: Providerid,
    servicioId: idService,
    unidadNegocioId: idBusinessUnit,
    eventoId,
    ...(requireRequest !== null && { requiereSolicitud: requireRequest })
  };
  const result = await apiAdminContracts.post(baseUrl, body);

  return result.data;
};
export const getNotification = async (idBusinessUnit, contractNumber) => {
  const baseUrl = '/v1/SolicitudesServicios/notificaciones';
  const result = await apiAdminContracts.get(
    `${baseUrl}?nroContrato=${contractNumber}&unidadNegocioId=${idBusinessUnit}`
  );

  return result.data;
};

export const getPositions = async (contract, mensualizadas) => {
  const url = `/v1/SolicitudesServicios/contratos/${contract}/posiciones`;
  const uriParameters = new URLSearchParams();

  if (mensualizadas !== null) {
    uriParameters.append('mensualizadas', mensualizadas);
  }
  const newURL = url.concat(`?${uriParameters.toString()}`);
  const result = await apiAdminContracts.get(newURL);

  return result.data;
};

export const getLines = async (contract, position, mensualizada) => {
  const url = `/v1/SolicitudesServicios/contratos/${contract}/posiciones/${position}/lineas`;
  const uriParameters = new URLSearchParams();

  if (mensualizada !== null) {
    uriParameters.append('mensualizadas', mensualizada);
  }
  const newURL = url.concat(`?${uriParameters.toString()}`);
  const result = await apiAdminContracts.get(newURL);

  return result.data;
};

export const getAlert = async (contract) => {
  const url = `/v1/SolicitudesServicios/contratos/${contract}/alertas`;
  const result = await apiAdminContracts.get(url);

  return result.data;
};

// Obtener las nros de contrato de un usuario por unidad de negocio
export const getNroContractsOfUser = async (ids) => {
  const result = await apiAdminContracts.post(`/contratos/contratosDeNotificador`, ids);

  return result.data;
};

/**
 * @param {numeroContrato: string} body
 * @returns {Promise<{statusCode: number, data:{id: number, nombre: string}[], message: string}>}
 */

export const getInspectorContracts = async (body) => {
  const result = await apiAdminContracts.post(`/contratos/Inspector`, body);

  return result.data;
};

/**
 * @param {numeroContrato: string} body
 * @returns {Promise<{statusCode: number, data:{id: number, nombre: string}[], message: string}>}
 */

export const getAprooverContracts = async (body) => {
  const result = await apiAdminContracts.post(`/contratos/aprobador`, body);

  return result.data;
};

/**
 * @param {numerosContrato: number[], nombreProveedor: string} body
 * @returns {Promise<{statusCode: number, data:{id: number, nombre: string}[], message: string}>}
 */
export const getProveedores = async (body) => {
  const result = await apiAdminContracts.post(`/contratos/proveedores`, body);

  return result.data;
};

/**
 * @param {numerosContrato: number[], nombreProveedor: string} body
 * @returns {Promise<{statusCode: number, data:{id: number, nombre: string}[], message: string}>}
 */
export const getProvidersForAproover = async (body) => {
  const result = await apiAdminContracts.post(`/contratos/aprobador/proveedores`, body);

  return result.data;
};

/**
 * @param {{nroContrato: number, operacionId: number}[]} body
 * @returns {Promise<{id: number, label: string, nombre: string, value: number}[]>}
 */
export const getInspectors = async (body) => {
  const result = await apiAdminContracts.post(
    '/v1/SolicitudesServicios/contratosOperaciones/inspectores',
    body
  );

  return getInspectorsAdapter(result.data);
};

/**
 * @param {{nroContrato: number, unidadNegocioId: number}[]} body
 * @returns {Promise<{id: number, label: string, nombre: string, value: number}[]>}
 */
export const getInspectorsEyM = async (body) => {
  const result = await apiAdminContracts.post(
    '/v1/SolicitudesServicios/contratos/inspectores',
    body
  );

  return getInspectorsAdapter(result.data);
};

/**
 * @param {{proveedor: string, opreacionId: number, servicioId: number}} body
 * @returns {Promise<{statusCode: number, data: {proveedores: {id: number, nombre: string}[]}, message: string}>}
 */
export const getOperationProvidersOyM = async (body) => {
  const result = await apiAdminContracts.post(
    '/v1/SolicitudesServicios/contratosOperaciones/proveedores',
    body
  );

  return result.data;
};

/**
 * @param {{proveedorId: number, operacionId: number, servicioId: number, requiereSolicitud: boolean}} body
 * @returns {Promise<{contratos :{id: number, nombre: stirng, requiereAceptacion: boolean, requiereAdjuntarArchivo: boolean, requiereSolicitud: boolean, moneda: string, inspectoresIds: number[]}[]}>}
 */
export const getOperationContractsOyM = async (body) => {
  const result = await apiAdminContracts.post(
    '/v1/SolicitudesServicios/contratosOperaciones',
    body
  );

  return result.data;
};

/**
 * @param {{nroContrato: number, idOperacion: number}[]} body
 * @returns {Promise<{aprobadores: {id: number, nombre: string, esGrupo: boolean, idProveedor: number, nroContrato: number}[]}>}
 */
export const getApproversOyM = async (body) => {
  const result = await apiAdminContracts.post(
    '/v1/SolicitudesServicios/contratosOperaciones/aprobadores',
    body
  );

  return result.data.data.aprobadores;
};

/**
 * @param {{nroContrato: number, idOperacion: number}} body
 * @returns {Promise<{statusCode: number, data: { default: {id: number, nombre: string}, opciones: {id: number, nombre: string}[]}, message: string}>}
 */
export const getNotificationOyM = async (body) => {
  const result = await apiAdminContracts.post(
    '/v1/SolicitudesServicios/contratosOperaciones/notifica',
    body
  );

  return result.data;
};

export const getPositionComment = async (contract, position) => {
  const result = await apiAdminContracts.get(
    `/v1/SolicitudesServicios/comentarioPosicion?nroContrato=${contract}&nroPosicion=${position}`
  );

  return result.data;
};

// POST contract approvers for OyM
export const postApproverContractOyM = async (body) => {
  try {
    const result = await apiAdminContracts.post(
      '/v1/SolicitudesServicios/contratosOperaciones/aprobadores',
      body
    );

    return result.data;
  } catch (error) {
    throw new Error(error?.data?.message || error?.message);
  }
};

export const getProvisionContract = async (name) => {
  try {
    const result = await apiAdminContracts.get(`/contratos/provision?filtro=${name}`);

    return result.data;
  } catch (error) {
    throw new Error(error?.data?.message || error?.message);
  }
};

// *Obtener combo de posiciones segun un contrato
/**
 * @param {string[]} contracts
 * @returns {Promise<{id: number, nombre: string}[]}
 */
export const getPositionsByContract = async (contracts) => {
  const result = await apiAdminContracts.post('/contratos/posiciones', contracts);

  return result.data;
};

// *Obtener combo de lineas segun contratos y posicion
/**
 * @param {string[]} contracts
 * @param {string} position
 * @returns {Promise<{id: number, nombre: string}[]}
 */
export const getLinesByPosition = async (contracts, position) => {
  const url = '/contratos/posiciones/lineas';
  const uriParameters = new URLSearchParams({ nroPosicion: position });
  const result = await apiAdminContracts.post(
    url.concat(`?${uriParameters.toString()}`),
    contracts
  );

  return result.data;
};
